import * as React from 'react';
import { SingleMeasurementTooltip } from '#components/charts/core/chart-tooltip/index.ts';
import { useIntl } from '@leagueplatform/locales';
import {
  LONG_WEEKDAY_DATE_FORMAT,
  useFormatDateByUserProfileLocation,
} from '@leagueplatform/web-common';
import { useLocaleUnitFormatter } from '#hooks/use-locale-unit-formatter.ts';
import { useLocaleMetricValueFormatter } from '#hooks/use-metric-value-formatter.ts';
import { HealthMetricChart } from '#components/charts/types/chart.ts';
import { CHART_VIEWS } from '#components/charts/constants/chart-views.ts';
import { MetricBarChart } from '../metric-bar-chart';

type EnergyBurnedBarChartProps = HealthMetricChart;

export function EnergyBurnedBarChart({
  data,
  view,
  type,
  unit,
}: EnergyBurnedBarChartProps) {
  const { formatMessage, $tifelse } = useIntl();
  const formatDateWithUserProfileLocation =
    useFormatDateByUserProfileLocation();
  const { formatUnit } = useLocaleUnitFormatter();
  const { formatMetricValue } = useLocaleMetricValueFormatter();

  return (
    <MetricBarChart
      yMaxFromEnums={0}
      data={data}
      view={view}
      type={type}
      description={$tifelse(
        view === CHART_VIEWS.WEEKLY,
        'INSIGHT_CHART_ENERGY_BURNED_WEEK_DESCRIPTION',
        'INSIGHT_CHART_ENERGY_BURNED_MONTH_DESCRIPTION',
        { unit },
      )}
      axisLeftLabel={`${formatMessage({
        id: 'INSIGHT_CARD_HEADER_ENERGY_BURNED',
      })} (${formatUnit(type, unit)})`.toLocaleUpperCase()}
      ariaDatumLabel={(datum) =>
        formatMessage(
          { id: 'INSIGHT_CHART_ENERGY_BURNED_DATUM_LABEL' },
          {
            energy: formatMetricValue(datum.value, type),
            unit: formatUnit(datum.type, datum.unit),
            date: formatDateWithUserProfileLocation(
              new Date(datum.timestamp),
              LONG_WEEKDAY_DATE_FORMAT,
            ),
          },
        )
      }
      renderTooltip={(datum) => (
        <SingleMeasurementTooltip
          title={formatMessage({ id: 'INSIGHT_CARD_HEADER_ENERGY_BURNED' })}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...datum}
        />
      )}
    />
  );
}
